// ===========================================
// SearchResultModal.js
// 童顏家行程日曆系統 - 市場搜尋結果彈窗元件
//
// 版本：V1.01 | 2024-07-05 20:10:00
// 主要功能：顯示市場搜尋結果（上次/下次拜訪）
// 解決問題：讓用戶快速查詢市場拜訪紀錄
//
// 版本紀錄：
// - V1.01 (2024-07-05): 初始版本，從 App.js 拆分
//
// 注意事項：
// - 僅負責顯示搜尋結果，不處理搜尋邏輯
// - 關聯檔案：App.js
// ===========================================
import React from 'react';

const SearchResultModal = ({ config, onClose }) => {
    if (!config.isOpen) return null;
    const { marketName, lastVisit, nextVisit } = config.data || {};
    const week = ['日', '一', '二', '三', '四', '五', '六'];
    const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return `${dateString} (週${week[date.getDay()]})`;
    };
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6" onClick={e => e.stopPropagation()}>
                <h2 className="text-2xl font-bold mb-4">市場搜尋結果</h2>
                <div className="space-y-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                        <h3 className="font-bold text-blue-800 mb-2">{marketName || '未知市場'}</h3>
                        <div className="text-sm text-blue-700">
                            <p>上次拜訪：{formatDate(lastVisit) || '無記錄'}</p>
                            <p>下次拜訪：{formatDate(nextVisit) || '無記錄'}</p>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <button onClick={onClose} className="bg-gray-200 text-gray-800 font-bold py-2 px-4 rounded-lg">關閉</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchResultModal; 